if ($('.campaign-slider').length > 0) {
	var slider = tns({
	  container: '.campaign-slider',
	  controlsContainer: '#campaignControls',
	  prevButton: '.prev1',
	  nextButton: '.next1',
	  autoplay: true,
	  items: 1,
	  swipeAngle: false,
	  navPosition: 'bottom',
	  lazyload: true,
	  mouseDrag: true,
	  speed: 400,
      responsive: {
        768: {
          items: 4
        }
      }
	});
}

var actionURL="/campaign/detail";

function openDetail(id, campaignTitle){
	var UC = net.kornr.unicode;
	
	if (typeof UC !== undefined){
		campaignTitle = UC.lowercase_nomark(campaignTitle);
	}
	campaignTitle = campaignTitle.replace(/\W+/g, " ").trim().replace(/ /g, '-');
	campaignTitle = encodeURI(campaignTitle);
	
	actionURL = URL_MAPPING.resolveUrl(actionURL);

	actionURL += '/' + campaignTitle + '?id='+id
	
	window.location = actionURL;

}


function imgError(img) {
    img.error="";
    $(img).hide();
}

$(document).ready(function() {
	$("a.villapopup").click(function(e){
		e.preventDefault();
		var detailwin=null;
		var winstatus = 'scrollbars=yes,menubar=no,height=865,width=780,resizable=yes,toolbar=no,location=no,status=no';
		var url = $(this).attr("href");
		if (detailwin == null || detailwin.closed)
			detailwin = window.open(url,'villaPopupWindow',winstatus);
		 else
		 	detailwin.location = url;
		
		if (!detailwin.opener)
			detailwin.opener = self;
		
		detailwin.focus();		
	});
//	$(".campaign-title").text($(this).text().substr(0, 105)+'...');
	$(".campaign-title").text(function(index, currentText) {
		if(currentText.length >= 73) {
	    return currentText.substr(0, 73)+"...";
		}
	});
	
});